export default function TimeLine({ dailySchedule, daysLength, weather }) {
  function translateWeather(dayNum) {
    if (weather) {
      switch (weather.split("+")[dayNum]) {
        case "snow":
          return "برفی";
        case "rain":
          return "بارانی";
        case "sun":
          return "آفتابی";
        default:
          return "اطلاعات در دسترس نیست.";
      }
    }
  }
  function getTimeLineItem(type) {
    var title = "";
    var description = "";
    switch (type) {
      case 0:
        title = "صبحانه";
        break;

      case 1:
        title = "گشت صبح";

        break;
      case 2:
        title = "ناهار";

        break;
      case 3:
        title = "گشت عصر";

        break;
      case 4:
        title = "میان وعده";

        break;
      case 5:
        title = "شام";

        break;
      case 6:
        title = "برنامه شب";
        break;
      default:
        break;
    }
    for (let index = 0; index < dailySchedule.length; index++) {
      if (dailySchedule[index].type == type && dailySchedule[index].ispublic) {
        switch (type) {
          case 1:
          case 3:
            return (
              <>
                <div className="timeline">
                  <div href="#" className="timeline-content">
                    <h3 className="title d-flex flex-row mb-2">{title}</h3>
                    <p className="description">{dailySchedule[index].description}</p>
                  </div>
                </div>
              </>
            );

          default:
            return (
              <>
                <div className="timeline">
                  <div href="#" className="timeline-content">
                    <h3 className="title d-flex flex-row mb-2">{dailySchedule[index].foodname == "" ? "بدون عنوان" : dailySchedule[index].foodname}</h3>
                    <p className="description">{dailySchedule[index].Account_side_name}</p>
                  </div>
                </div>
              </>
            );
        }
      }
    }
  }
  return (
    <>
      {/* timeline */}
      <div className="col-lg-8 col-sm-12 ">
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          {[...Array(daysLength)].map((value, index) => {
            return (
              <li className="nav-item" role="presentation">
                <button className={`nav-link Days  ${!index && " active"}`} id="home-tab" data-bs-toggle="tab" data-bs-target={`#day-tab-${index + 1}`} type="button" role="tab" aria-controls="home" aria-selected="true">
                  {index == 0 ? "روز حرکت" : `روز ${index}`}
                </button>
              </li>
            );
          })}
        </ul>
        <div className="tab-content" id="myTabContent">
          {[...Array(daysLength)].map((value, index) => {
            return (
              <div className={`tab-pane fade show ${!index && " active"}`} id={`day-tab-${index + 1}`} role="tabpanel" aria-labelledby="home-tab">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="main-timeline">
                        <p>
                          آب و هوا:
                          {translateWeather(index)}
                        </p>
                        {getTimeLineItem(0)}
                        {getTimeLineItem(1)}
                        {getTimeLineItem(2)}
                        {getTimeLineItem(3)}
                        {getTimeLineItem(4)}
                        {getTimeLineItem(5)}
                        {getTimeLineItem(6)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
